import {
  Autocomplete,
  CircularProgress,
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import BreadcrumbCentralWarehouse from "../BreadcrumbCentralWarehouse";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { getOutletList } from "../../../../services/outletApi";
import { useMutation, useQuery } from "@tanstack/react-query";
import { IoAddCircleOutline } from "react-icons/io5";
import { BsPencil, BsTrash } from "react-icons/bs";
import { LuMinusCircle, LuPlusCircle } from "react-icons/lu";
import {
  deleteCartWarehouse,
  getCartWarehouse,
  setWarehouse,
  updateCartWarehouse,
} from "../../../../services/centralWarehouseApi";
import { useNavigate } from "react-router-dom";
import { FaCheck } from "react-icons/fa";
import { cloneDeep } from "lodash";
import ModalConfirmationAction from "../../../common/particles.jsx/ModalConfirmationAction";
import LoadingBackdrop from "../../../common/particles.jsx/LoadingBackdrop";
import ModalAddProductWarehouse from "../ModalAddProductWarehouse";
import ModalAddWarehouse from "../ModalAddWarehouse";
import ModalDeleteProductWarehouse from "../ModalDeleteProductWarehouse";
import PagePagination from "../../../common/particles.jsx/PagePagination";
import TransactionHistory from "../common/TransactionHistory";

const toIDR = (val) =>
  val?.toLocaleString("id-ID", {
    style: "currency",
    currency: "IDR",
  });

const AddTransfer = () => {
  const [transferReq, setTransferReq] = useState({
    type: 2,
    target: null,
    date: moment().format("YYYY-MM-DD"),
  });
  const [cartLimit, setCartLimit] = useState(10);
  const [cartOffset, setCartOffset] = useState(1);
  const [openOverStok, setOpenOverStock] = useState(false);
  const [openAddProduct, setOpenAddProduct] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [editProduct, setEditProduct] = useState(false);
  const [deleteProduct, setDeleteProduct] = useState(null);
  const [addProductArr, setAddProductArr] = useState([]);

  const getStockOnHands = (id) => {
    const product = addProductArr.find((prod) => prod.id === id);
    return product.packaging.find((pack) => pack.uom === product.uom).stock;
  };

  const handleChangeValue = (id, newVal, type, action) => {
    var temp = [...addProductArr];
    const index = addProductArr.findIndex((prod) => prod.id === id);

    if (type === "stock" && action) {
      const maxVal = getStockOnHands(id);

      if (action === "min") temp[index].quantity -= 1;
      if (action === "add") {
        if (temp[index].quantity + 1 > maxVal) setOpenOverStock(true);
        temp[index].quantity =
          temp[index].quantity + 1 <= maxVal
            ? temp[index].quantity + 1
            : maxVal;
      }
      if (action === "text") {
        if (!isNaN(Number(newVal)) && Number(newVal) <= maxVal)
          temp[index].quantity = Number(newVal);
        if (isNaN(Number(newVal))) temp[index].quantity = 0;
        if (Number(newVal) > maxVal) setOpenOverStock(true);
      }
    }

    if (type === "packaging") {
      temp[index] = { ...temp[index], uom: newVal, quantity: 0 };
    }

    if (type === "pharmacy_net_price") {
      temp[index] = { ...temp[index], pharmacy_net_price: newVal };
    }

    if (type === "pharmacy_net_price_discount") {
      temp[index] = {
        ...temp[index],
        pharmacy_net_price_discount: newVal > 100 ? 100 : newVal,
      };
    }

    if (type === "pharmacy_net_price_ppn") {
      temp[index] = {
        ...temp[index],
        pharmacy_net_price_ppn: newVal,
        pharmacy_net_price_ppn_value: newVal ? 0.11 : 0,
      };
    }

    setAddProductArr(temp);
  };

  const getSubtotal = (product) => {
    return (
      product.pharmacy_net_price *
      ((100 - product.pharmacy_net_price_discount) / 100) *
      (1 + product.pharmacy_net_price_ppn_value)
    );
  };

  const refetchList = () => {
    setCartLimit(10);
    setCartOffset(1);
    mutateCart({
      type: 2,
      limit: cartLimit,
      offset: cartOffset,
    });
  };

  const handleUpdateCart = () => {
    const body = {
      type: 2,
      data: [
        ...addProductArr.map((item) => ({
          id: item.id,
          uom: item.uom,
          quantity: item.quantity,
          pharmacy_net_price: item.pharmacy_net_price,
          pharmacy_net_price_discount: item.pharmacy_net_price_discount,
          pharmacy_net_price_ppn: item.pharmacy_net_price_ppn,
          pharmacy_net_price_ppn_value: item.pharmacy_net_price_ppn_value,
          pharmacy_net_price_real: getSubtotal(item),
        })),
      ],
    };

    mutateUpdateCart(body);
  };

  const { data: dataOutlet, isFetching: isFetchingOutlet } = useQuery({
    queryFn: () => getOutletList(),
    queryKey: ["outlets"],
  });

  const { mutate: mutateUpdateCart, isLoading: isLoadingUpdate } = useMutation({
    mutationFn: updateCartWarehouse,
    onSuccess: () => {
      setEditProduct(false);
      refetchList();
    },
  });

  const { mutate: mutateDeleteCart, isLoading: isLoadingDelete } = useMutation({
    mutationFn: deleteCartWarehouse,
    onSuccess: () => refetchList(),
  });

  const { mutate: mutateClear, isLoading: isLoadingClear } = useMutation({
    mutationFn: deleteCartWarehouse,
    onSuccess: () => {
      setConfirm(false);
      setOpenSuccess(true);
    },
  });

  const {
    mutate: mutateCart,
    data: dataCartList,
    isLoading: isLoadingCart,
  } = useMutation({
    mutationFn: getCartWarehouse,
  });

  const { mutate: mutateTransfer, isLoading: isLoadingTransfer } = useMutation({
    mutationFn: setWarehouse,
    onSuccess: () => {
      mutateClear({ type: 2, is_success: true });
    },
    onError: () => {
      setConfirm(false);
    },
  });

  useEffect(() => {
    mutateCart({
      type: 2,
      limit: cartLimit,
      offset: cartOffset,
    });
  }, [cartLimit, cartOffset]);

  useEffect(() => {
    if (confirm) mutateTransfer(transferReq);
  }, [confirm]);

  return (
    <div className="text-[12px]">
      <LoadingBackdrop
        isLoading={
          isLoadingTransfer ||
          isLoadingDelete ||
          isLoadingClear ||
          isLoadingUpdate
        }
      />
      <BreadcrumbCentralWarehouse />
      <div className="block md:flex mb-4 items-start gap-4">
        <div className="w-full h-full">
          <div className="flex gap-4 items- mb-4">
            <Autocomplete
              fullWidth
              loading={isFetchingOutlet}
              disablePortal
              options={
                dataOutlet &&
                dataOutlet.filter(
                  (item) => item.status === 1 || item.status === 5
                ).length > 0 //&& !dataOutlet.every((outlet) => outlet.status !== 1)
                  ? dataOutlet.filter(
                      (item) => item.status === 1 || item.status === 5
                    )
                  : []
              }
              value={
                dataOutlet && transferReq.target
                  ? dataOutlet.find(
                      (item) => item.company_id === transferReq.target
                    )
                  : null
              }
              onChange={(_, inputValue) => {
                setTransferReq((prevValue) => ({
                  ...prevValue,
                  target: inputValue ? inputValue.company_id : null,
                }));
              }}
              getOptionLabel={(option) => option.company_name || ""}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Outlet Destination"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {isFetchingOutlet ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
            <div className="w-full">
              <DesktopDatePicker
                views={["year", "month", "day"]}
                fullWidth
                disablePast
                onChange={(newDate) =>
                  setTransferReq((prevValue) => ({
                    ...prevValue,
                    date: moment(newDate).format("YYYY-MM-DD"),
                  }))
                }
                value={transferReq.date}
                renderInput={(params) => {
                  return (
                    <TextField {...params} label="Transfer Date" fullWidth />
                  );
                }}
              />
            </div>
          </div>

          <div className="flex justify-between items-center w-full mb-4">
            <p className="font-bold">Selected Products</p>
            <div className="flex items-center gap-2">
              <button
                className="rounded-md bg-blue-500 text-white flex items-center gap-2 py-2 px-4 hover:bg-gray-300 disabled:bg-gray-300"
                onClick={() => setOpenAddProduct(true)}
                disabled={editProduct}
              >
                Tambah Product <IoAddCircleOutline />
              </button>
              <button
                className="rounded-md bg-blue-500 text-white flex items-center gap-2 py-2 px-4 hover:bg-gray-300 disabled:bg-gray-300"
                disabled={
                  isLoadingCart ||
                  !dataCartList ||
                  (dataCartList && !dataCartList.cart)
                }
                onClick={() => {
                  if (!editProduct === false) handleUpdateCart();
                  setAddProductArr(
                    !editProduct ? cloneDeep(dataCartList.cart) : []
                  );
                  setEditProduct(!editProduct);
                }}
              >
                {editProduct ? "Simpan" : "Edit Transfer"}
              </button>
            </div>
          </div>

          {dataCartList && !isLoadingCart && dataCartList.cart ? (
            <div className="flex w-full mb-4">
              <div className="w-full">
                <div className="block overflow-x-auto w-full rounded-md">
                  <table className="w-full overflow-x-auto rounded-md border-collapse">
                    <thead className="bg-blue-500 text-white">
                      <th className="py-2 text-center">No</th>
                      <th className="px-3 py-2 text-left whitespace-nowrap">
                        Product Name
                      </th>
                      <th className="px-3 py-2 text-left whitespace-nowrap">
                        Batch No
                      </th>
                      <th className="px-3 py-2 text-left whitespace-nowrap">
                        Expired Date
                      </th>
                      <th className="px-3 py-2 text-center whitespace-nowrap">
                        UOM
                      </th>
                      <th className="px-3 py-2 text-center whitespace-nowrap w-[250px]">
                        Qty
                      </th>
                      <th className="px-3 py-2 text-center whitespace-nowrap">
                        HNA
                      </th>
                      <th className="px-3 py-2 text-center whitespace-nowrap">
                        Diskon
                      </th>
                      <th className="px-3 py-2 text-center whitespace-nowrap">
                        PPN
                      </th>
                      <th className="px-3 py-2 text-left whitespace-nowrap">
                        Final Price
                      </th>
                      <th className="px-3 py-2 text-left whitespace-nowrap">
                        Total
                      </th>
                      <th></th>
                    </thead>
                    <tbody>
                      {dataCartList.cart.map((item, i) => (
                        <tr key={i}>
                          <td className="px-3 py-2 border text-center">
                            {" "}
                            {(cartOffset - 1) * cartLimit + (i + 1)}
                          </td>
                          <td className="px-3 py-2 border">
                            {item.product_name}
                          </td>
                          <td className="px-3 py-2 border">{item.batch}</td>
                          <td className="px-3 py-2 border">
                            {moment(item.expired_date).format("DD/MM/YY")}
                          </td>
                          <td className="px-3 py-2 border text-center w-[22%]">
                            {editProduct ? (
                              <FormControl fullWidth>
                                <Select
                                  disabled={!editProduct}
                                  value={addProductArr[i].uom}
                                  onChange={(e) => {
                                    handleChangeValue(
                                      addProductArr[i].id,
                                      e.target.value,
                                      "packaging",
                                      null
                                    );
                                  }}
                                >
                                  {addProductArr[i].packaging.map((pack) =>
                                    pack.uom < 2 ? (
                                      <MenuItem value={pack.uom}>
                                        {pack.name}
                                      </MenuItem>
                                    ) : null
                                  )}
                                </Select>
                              </FormControl>
                            ) : (
                              item.packaging.find(
                                (pack) => pack.uom === item.uom
                              ).name
                            )}
                          </td>
                          <td className="px-3 py-2 border text-center">
                            {!editProduct ? (
                              item?.quantity
                            ) : (
                              <div className="flex justify-center bg-slate-100 rounded-md border-2 p-1">
                                <button
                                  disabled={addProductArr[i]?.quantity === 0}
                                  className="text-red-500 hover:text-red-700"
                                  onClick={() => {
                                    handleChangeValue(
                                      addProductArr[i].id,
                                      0,
                                      "stock",
                                      "min"
                                    );
                                  }}
                                >
                                  <LuMinusCircle className="text-[16px]" />
                                </button>
                                <input
                                  type="text"
                                  className="bg-slate-100 p-2 w-[80px] text-center"
                                  value={addProductArr[i]?.quantity}
                                  onChange={(e) =>
                                    handleChangeValue(
                                      addProductArr[i].id,
                                      e.target.value,
                                      "stock",
                                      "text"
                                    )
                                  }
                                />
                                <button
                                  className="text-blue-500 hover:text-blue-700"
                                  onClick={() => {
                                    handleChangeValue(
                                      addProductArr[i].id,
                                      0,
                                      "stock",
                                      "add"
                                    );
                                  }}
                                >
                                  <LuPlusCircle className="text-[16px]" />
                                </button>
                              </div>
                            )}
                          </td>
                          <td className="px-3 py-2 border text-center min-w-[200px]">
                            {!editProduct ? (
                              toIDR(item?.pharmacy_net_price)
                            ) : (
                              <TextField
                                fullWidth
                                value={
                                  addProductArr[i]?.pharmacy_net_price
                                    ? addProductArr[
                                        i
                                      ]?.pharmacy_net_price.toString()
                                    : 0
                                }
                                type="number"
                                onFocus={(e) =>
                                  e.target.addEventListener(
                                    "wheel",
                                    function (e) {
                                      e.preventDefault();
                                    },
                                    { passive: false }
                                  )
                                }
                                onChange={(e) => {
                                  if (!isNaN(Number(e.target.value)))
                                    handleChangeValue(
                                      addProductArr[i].id,
                                      Number(e.target.value),
                                      "pharmacy_net_price",
                                      null
                                    );
                                }}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment>Rp</InputAdornment>
                                  ),
                                }}
                              />
                            )}
                          </td>
                          <td className="px-3 py-2 border text-center min-w-[100px]">
                            {!editProduct ? (
                              item?.pharmacy_net_price_discount + "%"
                            ) : (
                              <TextField
                                fullWidth
                                value={
                                  addProductArr[i]?.pharmacy_net_price_discount
                                    ? addProductArr[
                                        i
                                      ]?.pharmacy_net_price_discount.toString()
                                    : 0
                                }
                                type="number"
                                onFocus={(e) =>
                                  e.target.addEventListener(
                                    "wheel",
                                    function (e) {
                                      e.preventDefault();
                                    },
                                    { passive: false }
                                  )
                                }
                                onChange={(e) => {
                                  if (
                                    !isNaN(Number(e.target.value)) &&
                                    Number(e.target.value) < 100
                                  )
                                    handleChangeValue(
                                      addProductArr[i].id,
                                      Number(e.target.value),
                                      "pharmacy_net_price_discount",
                                      null
                                    );
                                }}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment>%</InputAdornment>
                                  ),
                                }}
                              />
                            )}
                          </td>
                          <td className="px-3 py-2 border text-center min-w-[100px]">
                            {!editProduct ? (
                              item?.pharmacy_net_price_ppn_value * 100 + "%"
                            ) : (
                              <Select
                                sx={{ width: "100%" }}
                                value={addProductArr[i]?.pharmacy_net_price_ppn}
                                onChange={(e) =>
                                  handleChangeValue(
                                    addProductArr[i].id,
                                    e.target.value,
                                    "pharmacy_net_price_ppn",
                                    null
                                  )
                                }
                              >
                                <MenuItem value={false}>Tanpa PPN</MenuItem>
                                <MenuItem value={true}>11%</MenuItem>
                              </Select>
                            )}
                          </td>
                          <td className="px-3 py-2 border">
                            {!editProduct
                              ? toIDR(item.hna)
                              : toIDR(getSubtotal(addProductArr[i]))}
                          </td>
                          <td className="px-3 py-2 border">
                            {toIDR(
                              editProduct
                                ? addProductArr[i]?.quantity *
                                    getSubtotal(addProductArr[i])
                                : item?.quantity * item.hna
                            )}
                          </td>
                          <td className="px-3 py-2 border text-center">
                            <div className="w-full flex justify-center items-center gap-2 text-[16px]">
                              <button
                                className="bg-red-500 hover:bg-gray-300 text-white p-2 rounded-md disabled:bg-gray-300"
                                disabled={editProduct}
                                onClick={() => setDeleteProduct(item.id)}
                              >
                                <BsTrash />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          ) : (
            <div className="flex justify-center text-gray-400 mb-4">
              {isLoadingCart ? (
                <CircularProgress size={20} />
              ) : (
                <p>There's no product added yet</p>
              )}
            </div>
          )}

          {dataCartList && !isLoadingCart && dataCartList.count > cartLimit ? (
            <PagePagination
              offset={cartOffset}
              setOffset={(e) => setCartOffset(e)}
              limit={cartLimit}
              setLimit={(e) => setCartLimit(e)}
              total={dataCartList.count}
            />
          ) : null}

          <div className="flex justify-end mt-4">
            <div className="w-1/2 flex gap-2">
              <button
                className="w-full rounded-md border-2 p-2 hover:bg-gray-300 disabled:bg-gray-300 disabled:text-white"
                onClick={() => mutateDeleteCart({ type: 2, is_success: false })}
                disabled={editProduct}
              >
                Clear
              </button>
              <button
                className="w-full rounded-md text-white bg-blue-500 hover:bg-gray-300 p-2 disabled:bg-gray-300"
                disabled={
                  transferReq.target === null ||
                  (dataCartList && !dataCartList.cart) ||
                  editProduct
                }
                onClick={() => setOpenAdd(true)}
              >
                Save
              </button>
            </div>
          </div>
        </div>
        <div className="w-full lg:w-1/2">
          <TransactionHistory
            title="Riwayat Transaksi Outlet"
            type={2}
            outlet={transferReq.target}
          />
        </div>
      </div>
      <ModalAddProductWarehouse
        open={openAddProduct}
        setOpen={setOpenAddProduct}
        type={2}
        refetch={() => {
          setCartOffset(1);
          setCartLimit(10);
          mutateCart({
            type: 2,
            limit: cartLimit,
            offset: cartOffset,
          });
        }}
      />

      <ModalAddWarehouse
        open={openAdd}
        setOpen={setOpenAdd}
        setConfirm={setConfirm}
        title="Confirm Transfer"
        message={`The selected product will be allocated to ${
          dataOutlet?.find((item) => item.company_id === transferReq.target)
            ?.company_name
        }, make sure you select the product properly`}
      />

      <ModalDeleteProductWarehouse
        open={deleteProduct}
        setOpen={setDeleteProduct}
        product={deleteProduct}
        type={2}
        refetch={() => {
          refetchList();
        }}
      />

      <ModalConfirmationAction
        open={openSuccess}
        setOpen={setOpenSuccess}
        message={"Product successfully allocated"}
        returnRoute={`/central-warehouse/transfer`}
      />

      <ModalConfirmationAction
        open={openOverStok}
        setOpen={setOpenOverStock}
        message={"Insufficient stock quantity"}
      />
    </div>
  );
};

export default AddTransfer;
